import type { NodeType, SchemaNormalizeFn } from '@gitbook/slate';

import { FRAGMENT_CAPTION, type INLINE_TYPES } from '../types';
import { canInsertInlineIn } from './canInsertInlineIn';

/**
 * Custom validator for block captions. Currently it checks for invalid inline
 * nodes inside captions.
 */
export function validateBlockCaption(node: NodeType): undefined | SchemaNormalizeFn {
    if (node.object === 'block') {
        const caption = node.fragments.get(FRAGMENT_CAPTION);
        if (!caption || caption.isEmpty) {
            return;
        }

        const invalidNode = caption.findDescendant((n) => {
            if (n.object === 'inline') {
                const parent = caption.getClosestBlock(n.key)!;

                // Return the invalid node if the inline cannot be inserted
                return !canInsertInlineIn(
                    { block: parent, nearestFragment: caption },
                    n.type as INLINE_TYPES
                );
            }
        });

        if (!invalidNode) {
            return;
        }

        return (change) => {
            change.removeNodeByKey(invalidNode.key);
        };
    }
}
